// src/context/AuthContext.jsx
import { auth, db } from "@/Firebase";
import { doc, getDoc } from "firebase/firestore";
import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
    setUser(currentUser);
    console.log("🔥 AuthStateChanged USER :", currentUser);

    if (currentUser) {
      try {
        const userDocRef = doc(db, "users", currentUser.uid);
        console.log("🔥 Firestore doc path => users /", currentUser.uid);

        const snap = await getDoc(userDocRef);

        console.log("🔥 snap.exists() =>", snap.exists());

        if (snap.exists()) {
          const data = snap.data();
          console.log("🔥 Données Firestore utilisateur =>", data);

          // adapte ici si besoin :
          setRole(data.role ?? data.type ?? data.userRole ?? null);
        } else {
          console.warn("⚠️ Aucun document Firestore trouvé pour cet UID");
          setRole(null);
        }
      } catch (error) {
        console.error("❌ Erreur récupération rôle :", error);
        setRole(null);
      }
    } else {
      console.log("👤 Pas d'utilisateur connecté");
      setRole(null);
    }

    setIsLoading(false);
  });

  return () => unsubscribe();
}, []);


  return (
    <AuthContext.Provider value={{ user, role, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
